import { useGetMainSearchQuery } from '@/app/(main)/search/hooks/useGetMainSearchQuery';
import { goToSearchDetails } from '@/app/(main)/search/utils/goToSearchDetailsPath';
import { SEARCH_CATEGORIES } from '@/consts/search-const';
import type { GlobalSearchCategory, GlobalSearchGalleryItem } from '@/types/globalSearchApiTypes';
import { CategoryWrapper } from '../CategoryWrapper';
import { GalleryItem } from '../GalleryItem';

interface GalleryCategoryProps {
  data: GlobalSearchCategory<GlobalSearchGalleryItem>;
}

export const GalleryCategory = ({ data }: GalleryCategoryProps) => {
  const { search } = useGetMainSearchQuery();

  return (
    <CategoryWrapper
      categoryName="Gallery"
      itemsCount={data.count}
      redirectToDetails={goToSearchDetails({ category: SEARCH_CATEGORIES.GALLERY, searchQuery: search })}
    >
      {data.results.map((item, index) => (
        <GalleryItem key={`${item.title}-${index}`} item={item} />
      ))}
    </CategoryWrapper>
  );
};